module.exports = __webpack_public_path__ + "static/media/G1.b11ea8be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gp/G1.jpg
// module id = 75
// module chunks = 0